import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

/**
 * Shared Action Centre data for dashboard widgets and toolbar.
 */
export function useActionCenter() {
  const [actionItems, setActionItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchActions = useCallback(async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setActionItems([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(`${API}/dashboard/action-center`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setActionItems(response.data.actions || []);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch action center:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActions();
  }, [fetchActions]);

  const openActionCenter = useCallback((moduleKey = 'all') => {
    window.dispatchEvent(
      new CustomEvent('dashboard-open-action-center', { detail: { module: moduleKey } })
    );
  }, []);

  return { actionItems, loading, error, refresh: fetchActions, openActionCenter };
}

export default useActionCenter;
